import $ from 'jquery';

/**
 * GDPR handling for third party video embeds, see src/embeds.php for the
 * server side part that defers the iframes (src moved to data-consent-src).
 *
 * - YouTube: blocked behind a consent message until the CookieScript
 *   "targeting" category is granted (or the visitor clicks "Visa video")
 * - Vimeo: always shown, but with dnt=1 (do not track) when not granted
 */

const CATEGORY = 'targeting';

function getGrantedCategories() {
    const match = document.cookie.match(/(?:^|;\s*)CookieScriptConsent=([^;]*)/);
    if (!match) {
        return [];
    }

    try {
        const data = JSON.parse(decodeURIComponent(match[1]));
        let categories = data.categories || [];
        if (typeof categories === 'string') {
            categories = JSON.parse(categories);
        }
        return Array.isArray(categories) ? categories : [];
    } catch {
        return [];
    }
}

const isGranted = () => getGrantedCategories().indexOf(CATEGORY) !== -1;

function showIframe($iframe, withDnt) {
    const consentSrc = $iframe.attr('data-consent-src');
    if (!consentSrc) {
        return;
    }

    let src = consentSrc;
    if (withDnt) {
        src += (src.indexOf('?') === -1 ? '?' : '&') + 'dnt=1';
    }

    $iframe.attr('src', src).removeAttr('data-consent-src');
    $iframe.siblings('.js-embed-consent').remove();
}

function applyConsent(granted) {
    $('iframe[data-consent-src]').each((i, el) => {
        const $iframe = $(el);
        const provider = $iframe.attr('data-consent-provider');

        if (provider === 'vimeo') {
            showIframe($iframe, !granted);
        } else if (granted) {
            showIframe($iframe, false);
        }
    });
}

function initEmbedConsent() {
    applyConsent(isGranted());

    // "Visa video" on a single blocked embed
    $(document).on('click', '.js-embed-consent-show', (e) => {
        const $message = $(e.currentTarget).closest('.js-embed-consent');
        showIframe($message.siblings('iframe[data-consent-src]'), false);
        $message.remove();
    });

    window.addEventListener('CookieScriptAccept', (e) => {
        const categories = (e.detail && e.detail.categories) || [];
        if (categories.indexOf(CATEGORY) !== -1) {
            applyConsent(true);
        }
    });

    window.addEventListener('CookieScriptAcceptAll', () => {
        applyConsent(true);
    });
}

export default initEmbedConsent;
